/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Better_On_PhoneInputs */

const en_dialog_better_on_phone = /** @type {(inputs: Dialog_Better_On_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Better experience on your phone`)
};

const es_dialog_better_on_phone = /** @type {(inputs: Dialog_Better_On_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor experiencia en tu teléfono`)
};

/**
* | output |
* | --- |
* | "Better experience on your phone" |
*
* @param {Dialog_Better_On_PhoneInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_better_on_phone = /** @type {((inputs?: Dialog_Better_On_PhoneInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Better_On_PhoneInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_better_on_phone(inputs)
	return en_dialog_better_on_phone(inputs)
});